<template>
  <div class="my" v-title data-title="个人中心">
    <header>
    </header>
    <section>
      <!-- 会员卡 -->
      <van-swipe :loop="true" >
        <van-swipe-item v-for="(item,index) in card_msg" :key="index">
          <div class="card-one">
            <div class="club-card" v-if="item.ismember == true" @click.stop="CardDetailsBtn(item.id)">
              <!-- 信息 -->
              <p class="card-ewm" @click.stop="shareBtn(item)">
                <img src="../../assets/images/my-img/12.png" alt="">
              </p>
              <p class="card-name">
                  {{item.username}}
                </p>
              <div class="card-information">
                <!-- 头像 -->
                <p class="head-portrait">
                  <img :src=item.avatar alt="">
                </p>
                <p class="card-name-tow">
                  {{item.name}}
                </p>
              </div>
              <!-- 公司名称 -->
              <div class="companyname">
                <p>
                  <!-- NO.101000001 -->
                  {{item.company}}
                </p>
                <p>
                  <!-- NO.101000001 -->
                  {{item.companyaddr}}
                </p>
              </div>
              <!-- 订单详情 -->
              <div class="order-details">
                <p>
                  <!-- NO.101000001 -->
                  {{item.card_no}}
                </p>
                <p>
                  有效期：{{item.endtime}}
                </p>
              </div>
              <!-- 等级 -->
              <!-- <div class="card-grade">
                <p>
                  <span>
                    lv1
                  </span>
                </p>
                <p>
                  <span>
                    lv2
                  </span>
                </p>
                <p>
                  <span>
                    lv3
                  </span>
                </p>
                <p>
                  <span>
                    lv4
                  </span>
                </p>
                <p>
                  <span>
                    lv5
                  </span>
                </p>
                < 进度条 -->
                <!-- <van-progress 
                  :percentage="card_grade" 
                  stroke-width="2"
                  pivot-text=""
                  color="#FFFFFFFF"
                /> -->
              <!-- </div> -->
            </div>
            <div class="club-card-no" v-else @click="CardDetailsBtn(item.id)">
              <!-- <p class="title">
                {{item.name}}
              </p>
              <p class="tuiguang">
                {{item.instructions}}
              </p>
              <p class="time" >有效期：<span>{{item.validity}}</span></p>
              <p class="money" >￥<span>{{item.pcate}}</span></p> -->
              <img :src="item.thumbnil" alt="">
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!-- 账户佣金 -->
      <!-- <account></account> -->
      <!-- 菜单 -->
      <memu :card_msg="card_msg"></memu>
    </section>
    <footer>
      <tabar></tabar>
    </footer>
  </div>
</template>
<script>

import account from '../../components/my/account'
import memu from '../../components/my/memu'

import wx from 'weixin-js-sdk'
import Vue from 'vue';
import { Progress, Swipe, SwipeItem } from 'vant';

Vue.use(Progress);
Vue.use(Swipe);
Vue.use(SwipeItem);

import tabar from '../../components/tabar/tabar'

export default {
  data(){
    return{
      card_grade:'0', // 进度条
      url: '' , // 当前路由路径
      not_card: false , // 是否买卡
      card_msg: [],
      endtime: '' , // 结束时间
    }
  },
  created(){
    this.url = window.location.href
    // 登录 / 分享登录
    let uid = JSON.parse(localStorage.getItem("uid"));
    if(!uid){
      let wxcode = this.$route.query.code
      // 获取code
      if(!wxcode){
        //appid 可以从后端传过来 也可以写死 
        let APPID = this.domain.APPID
        // 跳转回调redirect_uri 可以从后端传过来 也可以写死 但是url必须是公网可访问的
        let REDIRECT_URI = encodeURIComponent(window.location.href)
        // 返回类型
        let code = 'code';
        // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
        let SCOPE = 'snsapi_userinfo';
        let STATE = '123';//随便写
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + REDIRECT_URI + '&response_type=' + code + '&scope=' + SCOPE + '&state=' + STATE + '#wechat_redirect';
        window.location.href = url;
        // console.log(url)
        // console.log(encodeURIComponent(this.domain.local_url))
      }else{
        // 传code
        window.localStorage.removeItem('uid');
        let mypid = this.$route.query.pid
        if(!mypid){
          mypid = 0
        }
        this.$axios.get(this.domain.url+"/api/user/public/login",{
        params:{
          pid : mypid,
          code : wxcode,
          url : this.domain.local_url
        },
        }).then((res) => {
          // console.log(res.data.data.uid)
          window.localStorage.setItem('uid',JSON.stringify(res.data.data.uid));
        })
      }
    }else{
      this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) => {
        // console.log(res)
        if(res.data.code == 0){
          window.localStorage.removeItem('uid');
          this.$router.go(0)
        }
      })
    }

    // 查询会员
    this.$axios.get(this.domain.url + '/api/card/index/lists').then(res => {
      this.card_msg = res.data.data
      // console.log(this.card_msg)
    })
    // 调用微信自带分享
    // let usrId = JSON.parse(localStorage.getItem("uid"));
    // this.ShareImpl({
    //   shareTitle: 'KFM康养卡',
    //   shareDesc: '【限时特惠】截止4月30号之前，仅需99元可享本卡十年使用权',
    //   shareUrl: this.url + '?pid=' + usrId,
    //   shareImg: 'http://api.kfm666666.net/upload/default/20200325/adc9c0a6b2668b473901d315e3b845ef.jpg',
    // });
    
  },
  mounted(){
   
  },
  components:{
    tabar,
    account,
    memu
  },
  methods:{
    CardDetailsBtn(id){
      // console.log(id)
      this.$router.push({
        path:'/card-ecommend',
        query:{
          id : id
        }
      })
    },
    // 分享
    shareBtn(item){
      let usrId = JSON.parse(localStorage.getItem("uid"));
      window.location.href = "http://api.kfm666666.net/api/pay/index/wxshare?title=" + item.name + '&desc=' + item.instructions + '&imgurl=' + item.thumbnil + '&pid=' + usrId + '&link=' + 'http://members.kfm666666.net/card-ecommend?id=' + item.id
    },

    // 微信自带分享
    ShareImpl(option) {
      //option是分享的配置内容*/
      let aaa = window.location.href
      let usrId = JSON.parse(localStorage.getItem("uid"));
      this.$axios.get('http://members.kfm666666.net/api/share/index/wxshare?link=http://members.kfm666666.net/').then((response) => {
          wx.config({
              debug: false,
              appId: response.data.data.shareConfig.appId,
              timestamp: response.data.data.shareConfig.timestamp,
              nonceStr: response.data.data.shareConfig.nonceStr,
              signature: response.data.data.shareConfig.signature,
              jsApiList: [
                // 'updateAppMessageShareData',
                // 'updateTimelineShareData',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
              ]
          });
      }).catch(error => {
          window.console.log(error);
      });
      wx.ready(function () {
        // wx.updateAppMessageShareData({
        //     title: option.shareTitle,
        //     desc: option.shareDesc,
        //     link: option.shareUrl,
        //     imgUrl: option.shareImg,
        //     success:function(res){
        //       console.location(res)
        //     }
        // });
        // wx.updateTimelineShareData({
        //     title: option.shareTitle,
        //     desc: option.shareDesc,
        //     link: option.shareUrl,
        //     imgUrl: option.shareImg,
        //     success:function(res){
        //       console.location(res)
        //     }
        // });
        wx.onMenuShareTimeline({
            title: option.shareTitle,
            desc: option.shareDesc,
            link: option.shareUrl,
            imgUrl: option.shareImg,
            success:function(res){
              console.location(res)
            }
        });
        wx.onMenuShareAppMessage({
            title: option.shareTitle,
            desc: option.shareDesc,
            link: option.shareUrl,
            imgUrl: option.shareImg,
            success:function(res){
              console.location(res)
            }
        });
      })
      /*}*/
    }
  }
}
</script>
<style lang="less" scoped>
  .my{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    section{
      // display: flex;
      flex-direction: column;
      flex: 1;
      overflow: scroll;
      margin-bottom: 1rem;
      .van-swipe{
        width: 100%;
        height: 4.9rem;
        background-image: url(../../assets/images/my-img/black.png);
        background-size: 100% 100%;
      }
      /deep/.van-swipe__track{
        width: 7.5rem;
      }
      
    // 未购买
    .club-card-no{
      width: 6.9rem;
      height: 4rem;
      border-radius: .2rem;
      margin: 0 auto;
      // background-image: url(../../assets/images/my-img/card-no.png);
      background-size: 6.9rem 4rem;
      overflow: hidden;
      margin-top: .4rem;
      img{
        width: 6.9rem;
        height: 4rem;
      }
      .title{
        margin-top: 1.6rem;
        font-family: PingFang-SC;
        color: #734913;
        font-size: .6rem;
        font-weight: bold;
        margin-left: .44rem;
        line-height: .6rem;
      }
      .tuiguang{
        font-family: PingFangSC-Regular;
        font-size: .28rem;
        color: #734913;
        margin-left: .44rem;
        margin-top: .2rem;
      }
      .time{
        float: left;
        margin-left: .44rem;
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #734913;
        line-height: .24rem;
        margin-top: .2rem;
      }
      .money{
        float: right;
        margin-right: .4rem;
        font-family: PingFangSC-Regular;
        font-size: .28rem;
        line-height: .24rem;
        color: #734913;
        margin-top: .1rem;
          span{
            font-size: .56rem;
          }
        }
      }
      .card-one{
        height: 100%;
      }
      // 会员卡
      .club-card{
        width: 6.8rem;
        height: 4.02rem;
        border-radius: .2rem;
        margin: 0 auto;
        margin-top: .4rem;
        // background:linear-gradient(310deg,rgba(211,160,96,1) 0%,rgba(251,216,134,1) 57%,rgba(222,172,103,1) 100%);
        box-shadow: 0rem 0.01rem 0.1rem 0rem rgba(0,0,0,0.22);
        overflow: hidden;
        // margin-top: .4rem;
        // 信息
        &:first-child{
          background-image: url(../../assets/images/my-img/9.png);
          background-size: 6.8rem 4.02rem;
        }
        &:nth-child(2){
          background-image: url(../../assets/images/my-img/10.png);
          background-size: 6.8rem 4.02rem;
        }
        &:last-child{
          background-image: url(../../assets/images/my-img/11.png);
          background-size: 6.8rem 4.02rem;
        }
        // 分享
        .card-ewm{
          float: right;
          margin-right: .18rem;
          margin-top: .3rem;
          img{
            width: .43rem;
            height: .41rem;
          }
        }
        // 名字
        .card-name{
          width: 100%;
          float: left;
          font-family: PingFang-SC-Heavy;
          font-size: .36rem;
          color: #734913;
          font-weight: bold;
          text-align: center;
        }
        .card-information{
          height: .7rem;
          display: flex;
          align-items: center;
          margin-top: 1.5rem;
          margin-left: 1.07rem;
          text-align: center;
          // 头像
          .head-portrait{
            width: .6rem;
            height: .6rem;
            border-radius: 50%;
            float: left;
            border: .02rem #724913 solid;
            img{
              width: .6rem;
              height: .6rem;
              border-radius: 50%;
              // margin-top: .2rem;
            }
          }
          .card-name-tow{
            font-size: 0.54rem;
            font-family: FZYaSong-B-GBK;
            font-weight: 400;
            color: #724913;
            margin-left: .19rem;
          }
        }
        // 公司名称
        .companyname{
          float: left;
          margin-left: .4rem;
          margin-top: .8rem;
          p{
            font-size: 0.18rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #724913;
            line-height: .18rem;
            &:first-child{
            }
            &:last-child{
              margin-top: .18rem;
            }
          }
        }
        // 订单详情
        .order-details{
          float: right;
          margin-top: .85rem;
          margin-right: .22rem;
          p{
            font-size: 0.18rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #724913;
            line-height: .18rem;
            &:first-child{
    
            }
            &:last-child{
              margin-top: .09rem;
            }
          }
        }
        // 会员等级
        // .card-grade{
        //   width: 6.52rem;
        //   height: .02rem;
        //   margin: 0 auto;
        //   margin-top: .74rem;
        //   position: relative;
        //   // 等级标签
        //   p{
        //     display: inline-block;
        //     width: .6rem;
        //     height: .22rem;
        //     background: #ffffff;
        //     font-family: PingFang-SC-Medium;
        //     color: #734913;
        //     font-size: .16rem;
        //     text-align: center;
        //     line-height: .22rem;
        //     border-radius: .08rem;
        //     position: absolute;
        //     z-index: 1;
        //     span{
        //       display: inline-block;
        //       // -webkit-transform: scale(0.8);
        //     }
        //     &:first-child{
        //       left: .42rem;
        //       top: -.11rem;
        //     }
        //     &:nth-child(2){
        //       left: 1.82rem;
        //       top: -.11rem;
        //     }
        //     &:nth-child(3){
        //       left: 3.2rem;
        //       top: -.11rem;
        //     }
        //     &:nth-child(4){
        //       left: 4.6rem;
        //       top: -.11rem;
        //     }
        //     &:nth-child(5){
        //       left: 6rem;
        //       top: -.11rem;
        //     }
        //   }
        //   .van-progress{
        //     background: #734913;
        //   }
        // }
      }
    }
  }
</style>